import axios from 'axios'

export default {
  /**
   * Get the active website header logo (public - for header display)
   */
  getActive() {
    return axios.get('/api/website-header-logo/active')
  },

  /**
   * Get all website header logos (admin)
   */
  getAllAdmin() {
    return axios.get('/api/admin/website-header-logo')
  },

  /**
   * Activate a website header logo
   */
  activate(id) {
    return axios.post(`/api/admin/website-header-logo/${id}/activate`, { logo_id: id })
  },

  /**
   * Delete a website header logo
   */
  delete(id) {
    return axios.delete(`/api/admin/website-header-logo/${id}/destroy`)
  },

  /**
   * Update sort order for website header logos
   */
  updateOrder(ids) {
    return axios.post('/api/admin/website-header-logo/update-order', { ids })
  }
}
